<template>

  <div id="app" class="face">

    <div v-show="showContainer" class="face-capture"  id="face-capture">
      <p class="tip">请保持人像在取景框内</p>

      <video
        id="video"
        :width="vwidth"
        :height="vheight"
        playsinline
        webkit-playsinline>
        </video>

      <canvas id="refCanvas" :width="cwidth" :height="cheight"></canvas>
    </div>

    <div v-if="!showContainer" class="img-face">

      <img class="imgurl" :width="vwidth" :height="vheight" :src="imgUrl" />

    </div>
    <h3 class="contentp">{{ scanTip }}</h3>
    <!-- 加载状态 -->
     <div class="loadingBox" v-if="loading">
        <div class="loading">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <div class="loadText">识别中...</div>
        </div>
      </div>
  </div>

</template>

<script>

import tracking from "../faceJs/tracking-min";
import "../faceJs/data/face-min";
import "../faceJs/data/eye-min";
import "../faceJs/data/mouth-min";
import axios from 'axios'
import *as api from '@/utils/api'
export default {
  inject: ["reload"],
data() {
    return {
      screenSize: {
        width: window.screen.width,
        height: window.screen.height,
      },

      URL: null,

      streamIns: null, // 视频流

      showContainer: true, // 显示

      tracker: null,

      tipFlag: false, // 提示用户已经检测到

      flag: false, // 判断是否已经拍照

      context: null, // canvas上下文

      profile: [], // 轮廓

      removePhotoID: null, // 停止转换图片
      timer:null,
      scanTip: "人脸识别中...", // 提示文字

      imgUrl: "",

      canvas: null,

      trackertask: null,

      vwidth: "266",

      vheight: "266",

      cwidth: "266",

      cheight: "266",

      userInfo: {},

      orderData: {},

      loading:false,
      baseURL: process.env.NODE_ENV == "dev" ? "/devapi" : process.env.VUE_APP_PORT,
      faceTime:false
    };

  },
 beforeDestroy(){
   clearTimeout(this.timer)
    this.timer = null
},
mounted() {
    console.log('2',this.$route.query.path?this.$route.query.path:'home');
    //设置video canvas宽高

    const scale = this.screenSize.width / 375;

    this.vwidth = 266 * scale;

    this.vheight = 266 * scale;

    this.cwidth = 266 * scale;

    this.cheight = 266 * scale;

    this.playVideo();
  // this.compare('data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/4QBMRXhpZgAATU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAABFKADAAQAAAABAAABFAAAAAD/7QA4UGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/8AAEQgBFAEUAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/bAEMACQkJCQkJEAkJEBYQEBAWHhYWFhYeJh4eHh4eJi4mJiYmJiYuLi4uLi4uLjc3Nzc3N0BAQEBASEhISEhISEhISP/bAEMBCwwMEhESHxERH0szKjNLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS//dAAQAEv/aAAwDAQACEQMRAD8A8o2E01R1IODUvnhB8y/lTlmic4/nWQxgZxznNSiQ45FL5atyn6Uhi7ikA/dGeCBR5SN0NR7WFKB+lAEhgUjHBqBrKJu2PpUwLjkGpFd+4pgUUsSHyrYArSDPGM9frUilSCzdB/OonIYEnjNMCrKzklz6cYqFIlBMsnO3oPU//WqwFBRix5z3pzKFO0AkKv8APmgDPJwT16EmnLEzoCeu3rUZCqjHuTzWhbqzyKp+7gflj/69MCvHviXKjnp9PX86hddoJIG0Age+eM1bl5YBRlV6e/vUkqb9oPIHJPTNJDsZKQEsAR97pVoIGBxxjmrDqd4wMYAP9at20X7wg/d/xpisUVgOQDxnH5HvTWh2ngYZutbE1uOSARt5zTUi3EyE5pBYxFhIkPcjtTWjw7I3U1tG1xGHA5J60CxLDceoP6UBYxRC2/n8aniHO9eVPUd+K0zAEbjtxn1prQ+TMCgwsnX0B/8Ar0BYrRpI5No33jkqe3qBUQ5j3DjHBHoa0biFvJ+0RnBQ/jiqjER6gc/ckXn8f8DQAqqCpjk/h/T/AOtUyB48pzx1HpV1IyELsMlevuKbOI9yFOpUdfT/AOtQMrE5GaTCMMHmorhJosyRDd7VUF9GMBlIPeixJNJZQOcgbfpVN7Iqf3TfnVpbqEjCnJqYk9fWgDO33cZ5yQPxpy3q4xIuPcVfBGaa8cUnBANAFb7XD/epftcP979KRrKEnv8AnTfsMPv+dGgz/9Dy9LqCQfPj3pRHat93j6VRMMTdOPpSC3wcoxFZ2A0fs64+Rh+NP8mYdKys3Sf7QqZLyaP7ykUWAvfOpw4oDL0NRJqIJ+f9asLcW0g/wNKwxFA6CpkVuozTVWFvukg571J5UgXdH0X3oAiLEnk569arFsy4656UbiXYeg7UyEMZD3pgSKQNxPY4FLKSy4bv1/Cpig7/AN7p/n2qEr5hweaAR')

  },
methods: {

 playVideo() {
      this.getUserMedia({
       //摄像头拍摄的区域
          video: {
                width: 500,
                height: 500,
                facingMode: "user"} /* 前置优先 */
        },this.success,this.error);

    },

    // 访问用户媒体设备

getUserMedia(constrains, success, error) {
      if (navigator.mediaDevices.getUserMedia) {
        console.log(navigator.mediaDevices.getUserMedia);
        //最新标准API
        navigator.mediaDevices.getUserMedia(constrains).then(success).catch(error);
      } else if (navigator.webkitGetUserMedia) {

        //webkit内核浏览器

        navigator.webkitGetUserMedia(constrains).then(success).catch(error);

      } else if (navigator.mozGetUserMedia) {
        //Firefox浏览器
        navagator.mozGetUserMedia(constrains).then(success).catch(error);

      } else if (navigator.getUserMedia) {
        //旧版API
        navigator.getUserMedia(constrains).then(success).catch(error);
      } else {
        this.scanTip = "你的浏览器不支持访问用户媒体设备";
      }
    },
success(stream) {

      this.streamIns = stream;

      const video = document.getElementById("video");

      // webkit内核浏览器

      this.URL = window.URL || window.webkitURL;

      if ("srcObject" in video) {

        video.srcObject = stream;

      } else {

        video.src = this.URL.createObjectURL(stream);

      }

      // 苹果手机的系统弹框会阻止js的线程的继续执行 手动0.1秒之后自动执行代码

      setTimeout(() => {

        video.play();

        this.initTracker();// 人脸捕捉

      }, 100);

    },

error(e) {
    console.log('失败');

    this.scanTip = "访问用户媒体失败";
    
  
    },


// 人脸捕捉 设置各种参数 实例化人脸捕捉实例对象,注意canvas上面的动画效果。

initTracker() {

      this.context = document.getElementById("refCanvas").getContext("2d"); // 画布

      this.canvas = document.getElementById("refCanvas");

      this.tracker = new window.tracking.ObjectTracker(["face"]); // tracker实例

      this.tracker.setInitialScale(4);

      this.tracker.setStepSize(2); // 设置步长

      this.tracker.setEdgesDensity(0.1);

      try {

        this.trackertask = window.tracking.track("#video", this.tracker); // 开始追踪

      } catch (e) {

        this.scanTip = "访问用户媒体失败，请重试";

      }

      //开始捕捉方法 一直不停的检测人脸直到检测到人脸

      this.tracker.on("track", (e) => {

        //画布描绘之前清空画布

        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

        if (e.data.length === 0) {

          this.scanTip = "未检测到人脸";
        } else {

              e.data.forEach((rect) => {
            //设置canvas 方框的颜色大小

            this.context.strokeStyle = "#42e365";

            this.context.lineWidth = 1;

            this.context.strokeRect(rect.x, rect.y, rect.width, rect.height);

          });
          if (!this.tipFlag) {
            this.scanTip = "检测成功,正在拍照,请保持不动2秒";
          }
          // 1.5秒后拍照，仅拍一次 给用户一个准备时间
          // falg 限制一直捕捉人脸，只要拍照之后就停止检测
          if (!this.flag) {
              this.scanTip = "拍照中..."
              this.flag = true;
              this.removePhotoID = setTimeout(() => {
                this.tackPhoto();
                document.getElementById("video").pause();
                this.tipFlag = true;
            }, 1500)
            }

          }
      });
    },
// 6.拍照 绘制照片，计算照片大小，腾讯人脸比对接口对照片大小和格式有要求。
// 拍照
tackPhoto() {
                
// 在画布上面绘制拍到的照片

      this.context.drawImage(

        document.getElementById("video"),

        0,

        0,

        this.vwidth,

        this.vwidth

      );

      // 保存为base64格式

      this.imgUrl = this.saveAsPNG(document.getElementById("refCanvas"));

      /** 拿到base64格式图片之后就可以在this.compare方法中去调用后端接口比较，也可以调用getBlobBydataURI方法转化成文件再去比较
       * */
       this.showContainer = false;
        this.loading = true
        this.compare(this.imgUrl)
             //判断图片大小
      //  this.imgSize();
      

    },
imgSize() {

      if (this.imgUrl) {

        // 获取base64图片byte大小

        const equalIndex = this.imgUrl.indexOf("="); // 获取=号下标

        let size;

        if (equalIndex > 0) {

          const str = this.imgUrl.substring(0, equalIndex); // 去除=号

          const strLength = str.length;

          const fileLength = strLength - (strLength / 8) * 2; // 真实的图片byte大小

          size = Math.floor(fileLength / 1024); // 向下取整

          console.log("size", size + "KB");

        } else {

          const strLength = this.imgUrl.length;

          const fileLength = strLength - (strLength / 8) * 2;

          size = Math.floor(fileLength / 1024); // 向下取整

          console.log("size", size + "KB");

        }

        if (size > 1024) {

          // 图片超过1M 按比例压缩

          this.imgUrl = document

            .getElementById("refCanvas")

            .toDataURL("image/png", 1024 / size);

        }

      }

    },
    // Base64转文件
getBlobBydataURI(dataURI, type) {

      var binary = window.atob(dataURI.split(",")[1]);

      var array = [];

      for (var i = 0; i < binary.length; i++) {

        array.push(binary.charCodeAt(i));

      }

      return new Blob([new Uint8Array(array)], {

        type: type,

      });

    },
blobToFile(theBlob, fileName){
       theBlob.lastModifiedDate = new Date();
       theBlob.name = fileName;
       return theBlob;
    },
compare(url) {
    let blob = this.getBlobBydataURI(url, 'image/jpeg')

    var file = this.blobToFile(blob, '1.jpg');
      
    let formData = new FormData()
      formData.append('photo',file)
      const headers_ = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        };
      api.getFaceInfo(formData,{headers_}).then(res=>{
        const path = this.$route.query.path
          if(res.success){
          this.loading = false
            this.$dialog.alert({
            message: '<h1 style="font-size:18px;line-height:30px">认证成功</h1>',
            width:'300px'
              }).then(async(res) => {
                    let user = await api.getuser()

                    localStorage.setItem('userinfo',JSON.stringify(user))
                    this.$router.push({
                        name:this.$route.query.path?this.$route.query.path:'home',
                    })
                   
          });
     
          }else{
         this.$dialog.alert({
            message: '<h1 style="font-size:18px;line-height:30px">审核失败!请确保本人识别并正对摄像头</h1>',
            width:'300px'
              }).then(() => {
                this.close()
                this.reload()
          });
          
          }
   
          
      }).catch(error=>{
        this.loading = false
        this.$dialog.alert({
            message: '<h1 style="font-size:18px;line-height:30px">审核失败!请确保本人识别并正对摄像头</h1>',
            width:'300px'
              }).then(() => {
                this.close()
                this.reload()
          });
          
      })
     },
    // 保存为png,base64格式图片
saveAsPNG(c) {
      return c.toDataURL("image/jpeg", 0.4);
    },
// 7. 人脸采集之后，移除实例化对象，初始化参数和css样式部分代码
close() {
      this.loading = false
      this.flag = false;

      this.tipFlag = false;

      this.showContainer = false;

      this.context = null;

      this.scanTip = "人脸识别中...";

      clearTimeout(this.removePhotoID);
      clearTimeout(this.timer);
      this.timer = null
      if (this.streamIns) {

        this.streamIns.enabled = false;

        this.streamIns.getTracks()[0].stop();

        this.streamIns.getVideoTracks()[0].stop();

      }

      this.streamIns = null;

      this.trackertask.stop();
      
      this.tracker = null;
  
    }
},

}
</script>
<style lang="scss" scoped>
.face{
height: 100%;
background-color: #f6f6f6;
}
.face-capture {
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
}

.tip {
position: fixed;
top: 48px;
z-index: 5;
font-size: 26px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #333333;
line-height: 25px;
}

.face-capture video,
.face-capture canvas {
position: fixed;
top: 117.5px;
object-fit: cover;
z-index: 2;
background-repeat: no-repeat;
background-size: 100% 100%;
border-radius: 50%;
transform:rotateY(180deg);
-webkit-transform: rotateY(180deg)
}

.face-capture .img-cover {
position: fixed;
top: 63px;
width: 375px;
height: 375px;
object-fit: cover;
z-index: 3;
background-repeat: no-repeat;
background-size: 100% 100%;
}

.contentp {
position: absolute;
top: 800px;
width: 100%;
text-align: center;
font-size: 32px;
font-weight: 500;
color: #333333;
}

.face-capture .rect {
border: 2px solid #0aeb08;
position: fixed;
z-index: 4;
}

.img-face {
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
}

.img-face .imgurl {
position: fixed;
top: 117.5px;
// top: 600px;
border-radius: 50%;
transform:rotateY(180deg);
-webkit-transform: rotateY(180deg);
z-index: 9999;
}
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 120px;
    height: 120px;
    background-color: #fff;
  }
.loadingBox{
        width: 360px;
        height: 220px;
        background-color: rgba(128, 128, 128, 0.8);
        position: absolute;
        top: 780px;
        left: 50%;
        margin-left: -180px;
        border-radius: 15px;
}
.loading {
  width: 150px;
  height: 15px;
  margin-left: 130px;
  margin-top: 80px;
}

.loadText{
        color: #fff;
        width: 100%;
        margin-top: 6px;
        font-size: 28px;
}
.loading span {
  display: inline-block;
  width: 15px;
  height: 100%;
  margin-right: 5px;
  border-radius: 50%;
  background: #fff;
  -webkit-animation: load 1.04s ease infinite;
}
.loading span:last-child {
  margin-right: 0px;
}

@-webkit-keyframes load {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.loading span:nth-child(1) {
  -webkit-animation-delay: 0.13s;
}
.loading span:nth-child(2) {
  -webkit-animation-delay: 0.26s;
}
.loading span:nth-child(3) {
  -webkit-animation-delay: 0.39s;
}
.loading span:nth-child(4) {
  -webkit-animation-delay: 0.52s;
}
.loading span:nth-child(5) {
  -webkit-animation-delay: 0.65s;
}
</style>